import React,{ Component }  from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom'; // Use HashRouter to deploy in github
import MainPage from './main_page';
import VideoPlayer from './components/video_player';

class CVPage extends Component {
    render() {
        return (
            <div style={{ height: '100vh' }}>
                <h1>My CV</h1>
                <iframe
                    title="CV PDF"
                    src="CV.pdf"
                    width="100%"
                    height="100%"
                ></iframe>
            </div>
        );
    };
}

  
class App extends Component {
    render() {
        return (
            <Router>
                <Routes>
                <Route path="/" element={<MainPage />} />
                    <Route path="CAD_demo" element={<VideoPlayer videoPath='CAD_demo.mp4' videoTitle={'CAD_demo.mp4'}/>} />
                    <Route path="Duke_video" element={<VideoPlayer videoPath='duke_application.mp4' videoTitle={'Supplementary Video \nWhy I choose the neurobiology program at Duke'}  />} />
                    <Route path="CV" element={<CVPage />} />
                </Routes>
            </Router>
        )
    }
};

export default App;
